const React = require('react');
const {
  getRFC3339,
} = require('mn-utils/formatTime');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const ButtonUp = require('../../../dumb/Button/Up');
const HeaderA = require('../../../dumb/Header/A');
const RowB = require('../../../dumb/Row/B');
const ColB = require('../../../dumb/Col/B');
const TableItem = require("./components/TableItem");


module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/earnedMoney')
      .apiAdminEarnedMoneyList,
  wrapper(render, setState, self) {
    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Earned money</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin800 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin155 fx1">ID</ColB>
                    <ColB className="wmin120">Date & Time</ColB>
                    <ColB className="wmin200 fx1">User</ColB>
                    <ColB className="wmin100 fx1">CC Code</ColB>
                    <ColB className="wmin150 fx1">Fiat Value</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(TableItem)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
